import React from 'react';

const RecentSection = ({ recentApplications }) => (
  <div className="recent-section">
    <div className="recent-header">
      <h3>Recent Applications</h3>
      <span className="recent-count">{recentApplications.length} new</span>
    </div>
    <div className="recent-applications">
      {recentApplications.map((applicant, index) => (
        <div key={index} className="recent-card">
          <div className="recent-card-header">
            <div className="applicant-info">
              <h4>{applicant.first_name} {applicant.last_name}</h4>
              <span className="ats-number">{applicant.ats_number}</span>
            </div>
            <div className="application-date">
              {new Date(applicant.application_date).toLocaleDateString()}
            </div>
          </div>

          <div className="recent-card-body">
            <div className="contact-info">
              <span className="email">{applicant.email_id}</span>
            </div>
            <div className="details">
              <span className="domain">{applicant.domain || 'N/A'}</span>
              <span className="source">{applicant.source || 'Unknown'}</span>
            </div>
          </div>

          <div className="recent-card-footer">
            <div className="status-indicators">
              {applicant.attended_meet_greet && (
                <span className="status-indicator attended" title="Attended Meet & Greet"></span>
              )}
              {applicant.registered_startupworld && (
                <span className="status-indicator registered" title="Registered"></span>
              )}
              {applicant.assigned_project && (
                <span className="status-indicator assigned" title="Assigned Project"></span>
              )}
              {applicant.rejected && (
                <span className="status-indicator rejected" title="Rejected"></span>
              )}
              {applicant.left && (
                <span className="status-indicator left" title="Left Program"></span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default RecentSection;